import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { clas: "flex flex-column " }
const _hoisted_2 = { class: "w-full my-3 flex flex-column gap-1" }
const _hoisted_3 = { class: "w-full my-3 flex flex-column gap-1" }

import { ref } from 'vue';
import { storeToRefs } from 'pinia';
import Dialog from 'primevue/dialog';
import { useRelayHubStore } from '@/store';
import { EMIT } from '@/enum';


export default /*@__PURE__*/_defineComponent({
  __name: 'ConnectOrganizationModal',
  setup(__props, { emit: __emit }) {

const relayHubStore = useRelayHubStore();

const { organizationsAbleToConnect } = storeToRefs(relayHubStore);
const selectedItem = ref();
const district_medicaid_code = ref<string>();

const emit = __emit;

const modalVisible = ref(true);

const save = async () => {
  await relayHubStore.addNewOrganization(district_medicaid_code.value as string, selectedItem.value);
  if (relayHubStore.error) relayHubStore.doToast(relayHubStore.error as string, 'Error', true);
  else relayHubStore.doToast('Organization Connected');

  emit(EMIT.SAVE);
};

const cancel = () => {
  selectedItem.value = null;
  emit(EMIT.CANCEL);
};

return (_ctx: any,_cache: any) => {
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_AppButton = _resolveComponent("AppButton")!

  return (_openBlock(), _createBlock(_unref(Dialog), {
    visible: modalVisible.value,
    "onUpdate:visible": _cache[2] || (_cache[2] = ($event: any) => ((modalVisible).value = $event)),
    class: "dialog__container",
    modal: true,
    draggable: false,
    onHide: cancel
  }, {
    header: _withCtx(() => [...(_cache[3] || (_cache[3] = [
      _createElementVNode("div", { class: "dialog__header flex flex-column w-8" }, [
        _createElementVNode("h2", { class: "mb-3" }, "Connect Organization")
      ], -1)
    ]))]),
    footer: _withCtx(() => [
      _createVNode(_component_AppButton, {
        type: "secondary",
        text: "Cancel",
        onClick: cancel
      }),
      _createVNode(_component_AppButton, {
        type: "primary",
        text: "Connect Organization",
        disabled: !selectedItem.value || !district_medicaid_code.value,
        onClick: save
      }, null, 8, ["disabled"])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _cache[4] || (_cache[4] = _createElementVNode("label", {
            for: "organizations",
            class: "required"
          }, "Organizations", -1)),
          _createVNode(_component_Dropdown, {
            id: "organizations",
            modelValue: selectedItem.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedItem).value = $event)),
            class: "w-full",
            options: _unref(organizationsAbleToConnect),
            "option-label": "name",
            "option-value": "id",
            loading: _unref(relayHubStore).loading,
            placeholder: "Select an Organization"
          }, null, 8, ["modelValue", "options", "loading"])
        ]),
        _createElementVNode("div", _hoisted_3, [
          _cache[5] || (_cache[5] = _createElementVNode("label", {
            class: "required",
            for: "dmc"
          }, "District Medicaid Code", -1)),
          _createVNode(_component_InputText, {
            id: "dmc",
            modelValue: district_medicaid_code.value,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((district_medicaid_code).value = $event)),
            class: "w-full"
          }, null, 8, ["modelValue"])
        ])
      ])
    ]),
    _: 1
  }, 8, ["visible"]))
}
}

})